var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7279 19.2922L17.8331 15.3974C17.6573 15.2216 17.419 15.124 17.169 15.124H16.5323C17.6105 13.745 18.2511 12.0105 18.2511 10.1236C18.2511 5.63502 14.6142 1.99805 10.1256 1.99805C5.63697 1.99805 2 5.63502 2 10.1236C2 14.6122 5.63697 18.2492 10.1256 18.2492C12.0124 18.2492 13.7469 17.6085 15.1259 16.5303V17.1671C15.1259 17.4171 15.2236 17.6554 15.3994 17.8312L19.2942 21.726C19.6614 22.0932 20.2552 22.0932 20.6185 21.726L21.724 20.6204C22.0912 20.2532 22.0912 19.6594 21.7279 19.2922ZM10.1256 15.124C7.36365 15.124 5.12522 12.8894 5.12522 10.1236C5.12522 7.3617 7.35975 5.12326 10.1256 5.12326C12.8875 5.12326 15.1259 7.35779 15.1259 10.1236C15.1259 12.8855 12.8914 15.124 10.1256 15.124Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0bf4fce910721bb613fb79db11e06ed1.svg";
export { ForwardRef as ReactComponent };